class batchChecker extends HTMLElement {
  /** @type {object[]} */
  #formData = [];

  #form;
  #input;
  #error;
  #submitButton;
  #successElm;
  /** @type {NodeListOf<Element>} */
  #lotProductElms;
  /** @type {NodeListOf<Element>} */
  #lotNumberElms;
  /** @type {NodeListOf<Element>} */
  #expirationDateElms;
  #lotNumberPageButton;
  #resetButton;

  /** @type {() => void} */

  connectedCallback() {
    this.#formData = this.#parseFormData();

    this.#form = this.querySelector('[data-form]');
    this.#input = this.querySelector('input');
    this.#error = this.querySelector('[data-form-error]');
    this.#submitButton = this.querySelector('[data-submit-button]');

    this.#successElm = this.querySelector('[data-form-success]');
    this.#lotProductElms = this.#successElm.querySelectorAll('[data-lot-product]');
    this.#lotNumberElms = this.#successElm.querySelectorAll('[data-lot-number]');
    this.#expirationDateElms = this.#successElm.querySelectorAll('[data-expiration-date]');

    this.#lotNumberPageButton = this.querySelector('[data-lot-number-page-button]');
    this.#resetButton = this.querySelector('[data-form-reset]');

    this.#input.addEventListener('input', () => {
      this.#error.classList.add('hidden');
    });

    this.#form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.#onSubmit();
    });
    this.#submitButton.addEventListener('click', () => this.#onSubmit());
    this.#resetButton.addEventListener('click', () => this.#onReset());
  }

  /**
   * Metaobject lot entries embedded as JSON in the section.
   * @returns {object[]}
   */
  #parseFormData() {
    const jsonEl = this.querySelector('script[type="application/json"][data-batch-form-data]');
    const raw = jsonEl?.textContent?.trim() ?? '[]';
    try {
      return JSON.parse(raw);
    } catch {
      return [];
    }
  }

  #onSubmit() {
    const inputValue = this.#input.value;

    if (!this.#formData) {
      return;
    }

    const match = this.#formData.find((data) => data.lot_number === inputValue);

    if (match) {
      this.#fillSuccess(match);
      this.#successElm.classList.remove('hidden');
      this.#form.classList.add('hidden');
      this.#error.classList.add('hidden');
    } else {
      this.#error.classList.remove('hidden');
      this.#successElm.classList.add('hidden');
      this.#form.classList.remove('hidden');
    }
  }

  /**
   * @param {object} data - Matched lot metaobject payload
   */
  #fillSuccess(data) {
    if (this.#lotProductElms?.length && data.product) {
      this.#lotProductElms.forEach((el) => {
        el.textContent = data.product;
      });
    }

    this.#lotNumberElms.forEach((el) => {
      el.textContent = data.lot_number;
    });

    this.#expirationDateElms.forEach((el) => {
      el.textContent = data.expiration_date;
    });

    if (this.#lotNumberPageButton) {
      if (data.page_link) {
        this.#lotNumberPageButton.href = data.page_link;
        this.#lotNumberPageButton.classList.remove('hidden');
      } else {
        this.#lotNumberPageButton.href = '#';
        this.#lotNumberPageButton.classList.add('hidden');
      }
    }
  }

  #onReset() {
    this.#successElm.classList.add('hidden');
    this.#error.classList.add('hidden');
    this.#form.classList.remove('hidden');
    this.#input.value = '';

    if (this.#lotNumberPageButton) {
      this.#lotNumberPageButton.href = '#';
      this.#lotNumberPageButton.classList.remove('hidden');
    }

    const yOffset = -120;
    const scrollTo = this.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({ top: scrollTo, behavior: 'smooth' });
  }
}

if (!customElements.get('batch-checker')) {
  customElements.define('batch-checker', batchChecker);
}
